import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table/Table";
import tableData from "../../../utils/logistica/trasportoLogisticaData.json";
import { fetchMezzoViaggio, fetchTrasporti, fetchTrattori, fetchViaggio } from "../../../features/trasporti/trasportiThunk";
import { useEffect, useState } from "react";
import { fetchGiacenze } from "../../../features/giacenze/giacenzeThunk";
import { fetchMezzi, fetchMezzo } from "../../../features/Mezzi/mezziThunk";
import { CleanHands } from "@mui/icons-material";
const ViaggiMezzi = () => {
  const selectSelectedCompany = useSelector((state) => state.company.selectedCompany);
  const dispatch = useDispatch()
  const trasporti = useSelector((state) => state.trasporto?.trasporti);
  const giacenzeData = useSelector((store) => store.giacenze.giacenze);
  const loading = useSelector((state) => state.trasporto?.loading);
  const columns = [
    { field: "date_start", headerName: "Partenza il", width: 124, sorting: true },
    { field: "partenanza_da", headerName: "Luogo di partenza", width: 361, sorting: true },
    { field: "date_end", headerName: "Arrivo il", width: 224, sorting: true },
    { field: "destinazione_a", headerName: "Luogo di arrivo", width: 261, sorting: true },
    { field: "prodotto", headerName: "Prodotto", width: 222, sorting: true },
    { field: "qta_prodotto", headerName: "Q.ta prodotto", width: 224, sorting: true },
    { field: "status", headerName: "Stato", width: 357, sorting: true },
    { field: "azioni", headerName: "Azioni", width: 160, sorting: false }
  ];
  const [tableRows, setTableRows] = useState([]);
  // useEffect(() => {
  //   dispatch(fetchTrattori())
  //   dispatch(fetchMezzoViaggio())
  //   dispatch(fetchViaggio())
  //   dispatch(fetchGiacenze())
  //   dispatch(fetchMezzi())
  // }, [dispatch])
  useEffect(() => {
    dispatch(fetchTrasporti())
    dispatch(fetchGiacenze())
  }, [dispatch, selectSelectedCompany])
  useEffect(() => {
    // if (trasporti && trasporti.length > 0) {
      const mappedData = trasporti.map((item) => ({
        id: item.id,
        date_start: item.date_start,
        date_end: item.date_end,
        ore_viaggio: item.ore_viaggio,
        partenanza_da: item.partenanza_da,
        destinazione_a: item.destinazione_a,
        prodotto: giacenzeData.find(it => it.id === item.giacenze_id)?.name ||"N/A",
        qta_prodotto: giacenzeData.find(it => it.id === item.giacenze_id)?.displonibile || "N/A",
        status: item.status
      }))
      setTableRows(mappedData)
    // }
  }, [trasporti,giacenzeData])
  return (
    <>
      <div className="pageTemplate">
        <Table data={tableRows} columns={columns} navData={"viaggiLogistica"} deleteFunctions={"deleteTrasportoData"} />
      </div>
    </>
  );
};
export default ViaggiMezzi;